export default "__VITE_ASSET__DDVnoIFm__"